import { EvmWalletContext } from 'contexts/EvmWalletContext';
import { IEvmWalletContext } from 'contexts/EvmWalletProvider.types';
import { useContext } from 'react';

export const useEvmWalletContext = () =>
    useContext<IEvmWalletContext>(EvmWalletContext);
